export default __webpack_public_path__ + "2371441a.png";